/*
 * This variable is automatically overwritten during builds and releases.
 * It doesn't need to be updated manually.
 */

export var version = 'development'
